/**
 * tutorAvatarAdapter — la photo que le tuteur choisit → les champs de `updateAvatarSelected`.
 *
 * Port de `CustomizableAvatar.js` (« Choisir une image », `sendImage`) : le fichier s'appelle
 * `Avatar<nom d'affichage>_<AAAA-MM-JJ>.png` (`.jpg` quand la photo est un JPEG : celle, réduite, du web)
 * et part sous `avatar`, avec `avatar_characters: "image"` ;
 * « Réinitialiser » envoie les deux à vide.
 */
import moment from "moment"

export const AVATAR_IMAGE_CHARACTERS = "image"

/** Le corps de « Réinitialiser ». */
export const AVATAR_RESET_PAYLOAD = { avatar: null, avatar_characters: null }

export function tutorAvatarFileName(
    displayName: string | null | undefined,
    now: moment.Moment,
    mimeType?: string | null
): string {
    return `Avatar${displayName ?? ""}_${now.format("YYYY-MM-DD")}.${mimeType === "image/jpeg" ? "jpg" : "png"}`
}
